import { DOC_HOST, } from '../../base/constants/cgi-base';
// 获取协作者信息
export var GET_USER_MARKNAME = "".concat(DOC_HOST, "/sdc/getusermarkname");
// 设置匿名
export var SET_PERSONALIZE_ANONYMOUS = "".concat(DOC_HOST, "/api/personalize/anonymous/set");
// 查询匿名设置 这个接口能获取匿名过期的状态
export var GET_PERSONALIZE_ANONYMOUS = "".concat(DOC_HOST, "/api/personalize/anonymous/vip/get");
